export const PROFILE_CHANNEL_RECEIVED = 'profileChannelReceived'
